import _, { extend, each, findIndex } from 'lodash';
import { maybeToArray } from '../../utils/lang';
import { PermissionModule, } from './store/index';
import { T_Permission } from './store/permission';
export { T_Permission, };
function canUseDataResource(resources, code) {
    return findIndex(resources, r => r.code === code) > -1;
}
/**
 * 定义全局指令，显示涉及的权限内容
 * 输入：["a","b"] | "a"
 * 输入：[{permission: "a"},{permission: "b"}] | {permission: "a"}
 * alt + 鼠标右击键，控制台查看权限详情
 * debug 的值：systemService.Permission
 */
function registerDirective(Vue, $P_Desc, debug) {
    Vue.directive('Pdescription', {
        bind(el, bind) {
            if (!debug) {
                return;
            }
            const fn = (e) => {
                if (e.altKey && e.button === 2) {
                    console.group('Permission for', bind.value);
                    const descriptions = maybeToArray(bind.value);
                    _.each(descriptions, description => {
                        let permission = description;
                        if (!_.isString(description)) {
                            permission = description.permission;
                        }
                        console.log(`${permission}：${$P_Desc(permission)}`);
                    });
                    console.groupEnd();
                }
            };
            el.addEventListener('mousedown', fn);
            el.permission__disposeHandle = () => {
                el.removeEventListener('mousedown', fn);
            };
        },
        unbind(el, bing) {
            if (!debug) {
                return;
            }
            el.permission__disposeHandle();
        },
    });
}
export function install(Vue, options) {
    const store = options.store;
    options.store.registerModule('permission', PermissionModule);
    function updatePermissions(info) {
        store.commit('permission/updatePermissions', info);
    }
    function updateDataPermissions(data) {
        store.commit('permission/updateDataPermissions', data);
    }
    const getState = store => store.state.permission;
    function $P(p) {
        if (options.whiteListCheck) {
            if (options.whiteListCheck(p)) {
                return true;
            }
        }
        const res = getState(store).permission[p];
        if (_.isNil(res)) {
            console.error('Invalidate permission: ' + p);
            return false;
        }
        if (_.isBoolean(res)) {
            return res;
        }
        return res.Open;
    }
    function $P_Desc(p) {
        const res = getState(store).permission[p];
        if (_.isNil(res)) {
            console.error('Invalidate permission: ' + p);
            return 'Invalidate permission: ' + p;
        }
        if (_.isBoolean(res)) {
            return p;
        }
        return res.Description;
    }
    function $canUseDataResource(p) {
        return canUseDataResource(getState(store).dataResource, p);
    }
    const extendsFunctions = {
        updatePermissions,
        $P,
        $P_Desc,
        updateDataPermissions,
        $canUseDataResource,
    };
    each([Vue, Vue.prototype], target => {
        extend(target, extendsFunctions);
    });
    registerDirective(Vue, $P_Desc, options.debug);
}
